// extracted by mini-css-extract-plugin
export var baseButton = "_vk-0";
export var controlsArrowKeys = "_vk-1";
export var controlsResetButton = "_vk-2";
export var lightGameButton = "_vk-4 _vk-0";
export var playAgainButton = "_vk-5 _vk-0";
export var startGameButton = "_vk-3 _vk-0";